import * as AF from "src/types/formTemplate";
import * as GQL from "src/types/graphql";
import { SectionFormType } from "./SectionFormDrawer";

export const createNewSection = (values: SectionFormType): AF.V3.Section => {
  const base = {
    id: window.crypto.randomUUID(),
    type: values.type,
    title: values.title,
    description: values.description,
    key: values.key,
    familyEditableStatuses:
      values.familyEditableStatuses?.map((status) => status.id) ?? [],
    filters: [],
  };
  const permissionLevel = values.permissionLevelSwitch
    ? (values.permissionLevel as AF.V3.PermissionLevel)
    : undefined;
  switch (values.type) {
    case GQL.form_template_section_type_enum.SchoolRankingSection:
      return {
        ...base,
        minSchools: values.minSchools ? Number(values.minSchools) : undefined,
        maxSchools: values.maxSchools ? Number(values.maxSchools) : undefined,
        exploreUrl: values.exploreUrl,
        rankingEnabled: values.rankingEnabled,
      } as AF.V3.SchoolRankingSection;
    case GQL.form_template_section_type_enum.DisclaimerSection:
      return {
        ...base,
        permissionLevel,
        disclaimerFormSectionId: window.crypto.randomUUID(),
        disclaimer: "",
      } as AF.V3.DisclaimerSection;
    case GQL.form_template_section_type_enum.PreRankingSection:
      return {
        ...base,
        questions: [],
      } as AF.V3.Section;
    case GQL.form_template_section_type_enum.GeneralSection:
      return {
        ...base,
        permissionLevel,
        questions: [],
      } as AF.V3.Section;
    default: {
      throw new Error(`Unsupported section type: ${values.type}`);
    }
  }
};
